import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '100%',
  },

  option: {
    '&:hover': {
      background: theme.palette.border.main,
    },
  },
  button: {
    margin: theme.spacing(1),
    marginBottom: theme.spacing(0),
  },
}));

export default useStyles;
